/*
 * Custom: Quotes slider
 * Initializes accessible-slick on each "Custom: Quotes" section.
 * Loaded after custom-jquery.min.js and custom-accessible-slick.min.js (deferred, in order).
 */
(function () {
  function parseBool(value) {
    return value === 'true';
  }

  function initSlider(root) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) {
      return;
    }

    var $slides = $(root).find('.custom-quotes__slides');
    if (!$slides.length || $slides.hasClass('slick-initialized')) {
      return;
    }

    $slides.slick({
      dots: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 1000,
      fade: false,
      swipe: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      // accessible-slick options
      regionLabel: 'Quotes',
      useGroupRole: true
    });
  }

  function destroySlider(root) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) {
      return;
    }
    var $slides = $(root).find('.custom-quotes__slides');
    if ($slides.hasClass('slick-initialized')) {
      $slides.slick('unslick');
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('.custom-quotes');
    for (var i = 0; i < sections.length; i++) {
      initSlider(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  // document.addEventListener('shopify:section:load', function (event) {
  //   var el = event.target.querySelector('.custom-quotes');
  //   if (el) {
  //     initSlider(el);
  //   }
  // });

  // document.addEventListener('shopify:section:unload', function (event) {
  //   var el = event.target.querySelector('.custom-quotes');
  //   if (el) {
  //     destroySlider(el);
  //   }
  // });
})();
